import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useMemo } from 'react'
import { mapValuesToSelectOptions } from '../../utils/formUtils/forms'
import { fetchLocationValues } from './functions'
import { LocationValuesData } from './types/response'

const locations = {
    FormValues: {
        useQuery: (
            fields?: string[],
            formFilters?: Record<string, string | string[]>,
            options?: Omit<UseQueryOptions<LocationValuesData, AxiosError>, 'queryKey' | 'queryFn'>
        ) => {
            const query = useQuery({
                queryKey: ['locationValues', fields, formFilters],
                queryFn: () => fetchLocationValues(fields, formFilters),
                staleTime: Infinity,
                gcTime: Infinity,
                ...options,
            })

            const formattedData = useMemo(() => {
                return mapValuesToSelectOptions(query.data)
            }, [query.data])

            return {
                ...query,
                data: formattedData,
            }
        },
    },
}

export default locations
